import {
  faChevronRight,
  faCloud,
  faDesktop,
  faPaperPlane,
  faShoppingCart,
} from '@fortawesome/pro-solid-svg-icons';
import { SidebarManager } from '@core/app/scripts/services/sidebar-manager';
import { Contact } from '../../services/contact';

/**
 * Controller of the gateApp. Reponsible for /landing-page
 */
angular.module('gateApp').component('landingPage', {
  template: require('./landing-page.html').default,
  controller: function (
    $uibModal,
    $timeout: ng.ITimeoutService,
    $translate: ng.translate.ITranslateService,
    contact: Contact,
    sidebarManager: SidebarManager,
  ) {
    const $ctrl = this;

    $ctrl.faChevronRight = faChevronRight;
    $ctrl.faCloud = faCloud;
    $ctrl.faDesktop = faDesktop;
    $ctrl.faPaperPlane = faPaperPlane;
    $ctrl.faShoppingCart = faShoppingCart;

    $ctrl.contact = {};
    //Hide sidebar
    if (sidebarManager.exists()) {
      sidebarManager.register(undefined);
    }

    $ctrl.videos = [
      {
        type: 'mp4',
        file: require('../../../videos/clerk-shopper.mp4').default,
        image: require('../../../images/clerk-shopper.jpg'),
      },
      {
        type: 'mp4',
        file: require('../../../videos/guy-suites.mp4').default,
        image: require('../../../images/guy-suites.jpg'),
      },
      {
        type: 'mp4',
        file: require('../../../videos/happy-clerk.mp4').default,
        image: require('../../../images/happy-clerk.jpg'),
      },
      {
        type: 'mp4',
        file: require('../../../videos/three-women.mp4').default,
        image: require('../../../images/three-women.jpg'),
      },
      {
        type: 'mp4',
        file: require('../../../videos/woman-shopping.mp4').default,
        image: require('../../../images/woman-shopping.jpg'),
      },
    ];

    $ctrl.aboutSectionBackgroundImage = require('../../../images/hipster.jpg');

    $ctrl.openQuoteModal = () => {
      $uibModal.open({
        template: require('./../../../views/modals/quote-modal.html').default,
        windowClass: 'sw-modal sw-quote-modal',
        controller: function (
          $timeout: ng.ITimeoutService,
          $uibModalInstance,
          contact,
        ) {
          const $ctrl = this;

          $ctrl.faPaperPlane = faPaperPlane;

          $ctrl.isSending = false;
          $ctrl.quote = {};
          $ctrl.requestQuote = (user) => {
            $ctrl.isSending = true;
            user = Object.assign(user, {
              message: 'User Requests A Quote',
              subject: 'Quote Requested',
            });

            contact.us(user);

            $timeout(() => {
              //send and close modal
              $uibModalInstance.close();
              $ctrl.user = {};
            }, 2000);
          };
        },
        controllerAs: '$ctrl',
      });
    };

    $ctrl.organisationType = [
      {
        type: $translate.instant('gate.landing-page.contact.form.retail'),
        value: 'retail',
      },
      {
        type: $translate.instant('gate.landing-page.contact.form.wholesale'),
        value: 'wholesale',
      },
      {
        type: $translate.instant('gate.landing-page.contact.form.both'),
        value: 'both',
      },
      {
        type: $translate.instant('gate.landing-page.contact.form.neither'),
        value: 'none',
      },
    ];

    $ctrl.contact.category = $ctrl.organisationType[0];

    $ctrl.sendContact = (contactInfo) => {
      // The subject of the email received by us:
      contactInfo.subject = `Contact request from: ${contactInfo.name}`;
      contact
        .us(
          contactInfo.name,
          contactInfo.email,
          contactInfo.subject,
          contactInfo.message,
          contactInfo.phone,
          contactInfo.category.value,
        )
        .then(() => {
          $ctrl.isContactSent = true;

          $timeout(() => {
            $ctrl.contactForm.$setUntouched();
            $ctrl.contact = {};
            $ctrl.contact.category = $ctrl.organisationType[0];
            $ctrl.isContactSent = false;
          }, 2000);
        });
    };
  },
});
